/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Streamers_BodyInputs */

const ja_playdata_home_streamers_body = /** @type {(inputs: Playdata_Home_Streamers_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このシンプルなツールで人気ストリーマーを発見・分析できます。最も効果的な配信タレントをすばやく特定したり、ストリーマー主導のキャンペーンの成果を測定したりできます。`)
};

const en_playdata_home_streamers_body = /** @type {(inputs: Playdata_Home_Streamers_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover and analyse popular streamers with this simple tool. Quickly identify the most effective streaming talents or measure the performance of your streamer led campaign.`)
};

/**
* | output |
* | --- |
* | "Discover and analyse popular streamers with this simple tool. Quickly identify the most effective streaming talents or measure the performance of your stream..." |
*
* @param {Playdata_Home_Streamers_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_streamers_body = /** @type {((inputs?: Playdata_Home_Streamers_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Streamers_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_streamers_body(inputs)
	return en_playdata_home_streamers_body(inputs)
});